// extracted by mini-css-extract-plugin
export default {"noDataPic":"editProtectedSpaces_noDataPic__dbucS"};